export { BuyWithPrimePLP } from './BuyWithPrimePLP';
